import { render, staticRenderFns } from "./CreateBusinessUnit.vue?vue&type=template&id=26797ce8&scoped=true"
import script from "./CreateBusinessUnit.vue?vue&type=script&lang=js"
export * from "./CreateBusinessUnit.vue?vue&type=script&lang=js"
import style0 from "./CreateBusinessUnit.vue?vue&type=style&index=0&id=26797ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26797ce8",
  null
  
)

export default component.exports